<template>
  <div class="reset">
    <p>{{`${$t('username')}: ${username}`}}</p>
    <p>{{`${$t('pwd')}: ${pwd}`}}</p>
    <div class="foot">
      <el-button @click="cancel" size="mini">{{$ct('confirm')}}</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
p {
  text-indent: 50px;
  line-height: 30px;
}
.foot {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
</style>

<script>

export default {
  props: {
    username: String,
    pwd: String
  },
  data() {
    return {

    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<i18n lang="yaml">
en:
  username: Username
  pwd: reset password
zh-CN:
  username: 学生账号为
  pwd: 重置密码为
zh-TW:
  username: 學生賬號為
  pwd: 重置密碼為
it:
  username: Username
  pwd: resetta la password
id:
  username: Nama Pengguna
  pwd: Atur ulang kata sandi
</i18n>
